import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectWorkExperienceInternal  {
    _originalTypeClassName = "zERP.BO.ProjectWorkExperienceInternal";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectWorkExperienceInternal.translate = translateService;
}
this.Id = null;
this.Code = null;
this.Duties = null;
this.DateFrom = null;
this.DateTo = null;
this.DurationYear = null;
this.DurationMonth = null;
this.DurationDay = null;
this.Comments = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Duties:any;
DateFrom:any;
DateTo:any;
DurationYear:any;
DurationMonth:any;
DurationDay:any;
Comments:any;
Project:any;
Employee:any;
MemberRole:any;
Characterization:any;
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
}
}
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}
static setMemberRole = ($this, value) => {
var oldValue = $this.MemberRole;
$this.MemberRole = value;
if (value != null) {
}
}
static setCharacterization = ($this, value) => {
var oldValue = $this.Characterization;
$this.Characterization = value;
if (value != null) {
}
}

static GetClassName(): any{return "ProjectWorkExperienceInternal";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}